// English is LanguageId 1 in the system labels API; it can be edited but not removed.
export const ENGLISH_LANGUAGE_ID = 1;

// Per-language text lists ({ LanguageId, Message }) used by the add form and the translations editor.
export const addLanguage = (translations, languageId) =>
  translations.some((t) => t.LanguageId === languageId)
    ? translations
    : [...translations, { LanguageId: languageId, Message: "" }];

export const updateMessage = (translations, languageId, message) =>
  translations.map((t) =>
    t.LanguageId === languageId ? { ...t, Message: message } : t
  );

export const removeLanguage = (translations, languageId) =>
  translations.filter((t) => t.LanguageId !== languageId);
